import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { Button } from "@/components/ui/button";

/**
 * Shows a fullscreen overlay when the device is offline,
 * since the app requires internet connection.
 */
const OfflineBanner = () => {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-background/95 backdrop-blur-sm flex flex-col items-center justify-center gap-4 p-6 text-center animate-in fade-in duration-300">
      <div className="bg-destructive/10 p-6 rounded-full">
        <WifiOff className="w-12 h-12 text-destructive" />
      </div>
      <h2 className="text-xl font-bold text-foreground">Sem conexão</h2>
      <p className="text-muted-foreground max-w-xs">
        O Paróquia Viva precisa de internet para funcionar. Verifique sua conexão e tente novamente.
      </p>
      <Button
        variant="outline"
        onClick={() => window.location.reload()}
        className="mt-2"
      >
        Tentar novamente
      </Button>
    </div>
  );
};

export default OfflineBanner;
